import {
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
} from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { ModalCloseMethod } from '@rivethealth/data/analytics/account-analytics-events';
import { isArray } from 'lodash';
import { ChangeService } from '../core/change.service';
import { Loadable } from '../helpers/loadable';

@Component({
  selector: 'modal-form',
  styleUrls: ['./modal-form.component.scss'],
  templateUrl: './modal-form.component.html',
  providers: [ChangeService],
})
export class ModalFormComponent implements OnInit {
  @Input() compact: boolean = false;

  @Input() submitText: string = 'Submit';

  @Input() submittingText: string = 'Submitting...';

  @Input() allowOverflow: boolean = false;

  @Input() submitting: boolean = false;

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly changeService: ChangeService,
  ) {}

  @Input() focus: HTMLInputElement;

  @Input() outerWidth: string;
  @Input() width: string;

  @ContentChildren(NgModel, { descendants: true })
  controls: QueryList<NgModel>;

  @ViewChild('form', { static: true }) form: NgForm;

  @Input() readonly = false;
  @Input() disabled = false;
  @Input() submitTooltip: string;

  @Input() load: Loadable<any> | Loadable<any>[];
  @Input() loadableClass: string;
  @Input() loading = false;
  @Input() erred = false;

  @Input() backgroundShading = true;

  @Input()
  deleteText: string | null = null;

  get anyLoading(): boolean {
    if (!this.load) {
      return this.loading;
    }
    if (isArray(this.load)) {
      return this.load.some(({ loading }) => loading);
    } else {
      return this.load.loading;
    }
  }

  @Input() title: string;

  @Input() submit: () => Promise<void>;

  @Input() overrideFooter = false;

  @Output() close = new EventEmitter();

  @Output() submitted = new EventEmitter();

  @Output()
  delete = new EventEmitter();

  ngOnInit() {
    if (this.focus) {
      this.focus.focus();
    }
  }

  private controlList: NgModel[];
  ngAfterViewInit() {
    this.changeService.listen(this.controls.changes, controls => {
      if (this.controlList) {
        for (const control of this.controlList) {
          this.form.removeControl(control);
        }
      }
      for (const control of controls) {
        if (!control.options || !control.options.standalone) {
          this.form.addControl(control);
        }
      }
      this.controlList = controls;
    });
  }

  async formSubmit(canSubmit: boolean) {
    if (!canSubmit) {
      return;
    }
    this.submitted.emit();
    if (this.submit) {
      this.submitting = true;
      try {
        await this.submit();
        this.close.emit();
      } catch (e) {
      } finally {
        this.changeDetector.markForCheck();
        this.submitting = false;
      }
    }
  }

  public isSubmitted() {
    return this.form.submitted;
  }

  closeMethodRef: { method: ModalCloseMethod } | undefined = undefined;
  setCloseMethod(method: ModalCloseMethod) {
    if (this.closeMethodRef) {
      this.closeMethodRef.method = method;
    }
  }
}
